var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('el-link',{attrs:{"type":"primary"},on:{"click":_vm.handelClick}},[_vm._v(_vm._s(_vm.text))]):_c('ml-button',{attrs:{"text":_vm.text,"size":_vm.size,"round":_vm.round,"icon":_vm.icon},nativeOn:{"click":function($event){return _vm.handelClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }